/**
 * @desc 仓库列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.WarehouseParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/warehouse/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
